import React, { ReactElement, useState } from 'react'
import { setUploadCount } from '../services/utils'
import ModalContainer from './Modal/ModalContainer'
import ResetJourney from './Modal/ResetJourney'
import ResetHook from '../hooks/ResetHook'
import { alertIcon, phone } from '../assets/images/images'

function Footer({
  showResetButton = false,
}: {
  showResetButton?: boolean
}): ReactElement {
  const [modalOpen, setModalOpen] = useState(false)
  const { resetFolder } = ResetHook()

  return (
    <footer className="footer textCenter flexShrink0">
      <img className="mb12" src={phone} alt="Phone" />
      <p>Une difficulté ? Une question ?</p>
      <p>Contactez-nous au : 01 44 88 30 05</p>
      <p>
        ou par mail en cliquant{' '}
        <a
          href="mailto:pole.connaissance-client@louvrebanqueprivee.fr?subject=Aide à la mise à jour de mon dossier client"
          className="textUnderline textPrimary"
        >
          ICI
        </a>
      </p>
      {showResetButton && (
        <div className="px15">
          <p className="dInlineFlex alignItemsCenter justifyContentCenter flexWrap mt15 fontWeightBold">
            <img
              src={alertIcon}
              alt="QuestionIcon"
              className="mr05sm mb05 mb0sm"
            />
            <span
              className="btnLink linkDefault wFull wAutoSm dInlineBlock"
              onClick={() => setModalOpen(true)}
            >
              Une erreur de saisie ? Cliquez ici pour recommencer
            </span>
          </p>
          <ModalContainer isOpen={modalOpen}>
            <ResetJourney
              onClose={() => setModalOpen(false)}
              onConfirm={() => {
                resetFolder()
                setUploadCount(0)
                setModalOpen(false)
              }}
            />
          </ModalContainer>
        </div>
      )}
    </footer>
  )
}

export default Footer
